function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bgGradient",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FEF3EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F2704E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cardGradient",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFFFF",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFFFF",
  stopOpacity: 0.74
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1200,
  height: 675,
  fill: "url(#bgGradient)"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(180, 140)",
  opacity: 0.22
}, /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 48,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 180,
  y: 20,
  width: 96,
  height: 96,
  rx: 18,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "420,10 480,110 360,110",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 620,
  cy: 60,
  r: 40,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 720,
  y: 30,
  width: 80,
  height: 60,
  rx: 8,
  fill: "#FFFFFF"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(180, 440)",
  opacity: 0.22
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 80,
  rx: 12,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 40,
  r: 40,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 340,
  y: 10,
  width: 80,
  height: 60,
  rx: 30,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "520,0 580,80 460,80",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 680,
  cy: 40,
  r: 36,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 760,
  y: 10,
  width: 60,
  height: 60,
  rx: 12,
  fill: "#FFFFFF"
}));
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 260,
  y: 240,
  width: 680,
  height: 200,
  rx: 24,
  fill: "url(#cardGradient)"
});
var _ref7 = /*#__PURE__*/React.createElement("text", {
  x: 600,
  y: 325,
  fontFamily: "Inter, 'Open Sans', system-ui, sans-serif",
  fontSize: 52,
  fontWeight: 700,
  fill: "#101828",
  textAnchor: "middle"
}, "STEM Toy Rentals");
var _ref8 = /*#__PURE__*/React.createElement("text", {
  x: 600,
  y: 375,
  fontFamily: "Inter, 'Open Sans', system-ui, sans-serif",
  fontSize: 22,
  fontWeight: 500,
  fill: "#F2704E",
  textAnchor: "middle"
}, "From home. On your schedule.");
var _ref9 = /*#__PURE__*/React.createElement("text", {
  x: 600,
  y: 410,
  fontFamily: "Inter, 'Open Sans', system-ui, sans-serif",
  fontSize: 14,
  fontWeight: 400,
  fill: "#101828",
  opacity: 0.6,
  textAnchor: "middle"
}, "Placeholder \u2014 swap before launch");
function SvgStemToysHeroPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    role: "img",
    "aria-label": "STEM toy rental business starter kit with robotics and science sets",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStemToysHeroPlaceholder);
export default __webpack_public_path__ + "static/media/stem-toys-hero-placeholder.f8f662d90a41ba33a75b5ecd5ee1f553.svg";
export { ForwardRef as ReactComponent };